export default class ProduitsEcoOrganismeService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	/**
	 * Récupérer la liste des produits éco-organisme pour une société
	 * @param {number} societeId - ID de la société
	 * @returns {Promise<Array>} - La liste des produits
	 */
	async getProduits(societeId) {
		const url = `${__configuration.apiUrl}/massia/eco-organisme-inertes`;
		const res = await this.$http.get(url, {
			params: { idSociete: societeId }
		});
		return res.data;
	}

	/**
	 * Créer un nouveau produit éco-organisme
	 * @param {number} societeId - ID de la société
	 * @param {object} produit - Données du produit { codeDechet, denominationDechet }
	 * @returns {Promise<object>} - Le produit créé
	 */
	async createProduit(societeId, produit) {
		const url = `${__configuration.apiUrl}/massia/eco-organisme-inertes/societes/${societeId}`;
		const res = await this.$http.post(url, produit);
		return res.data;
	}

	/**
	 * Mettre à jour un produit éco-organisme
	 * @param {number} societeId - ID de la société
	 * @param {number} produitId - ID du produit
	 * @param {object} produit - Données du produit { codeDechet, denominationDechet }
	 * @returns {Promise<object>} - Le produit mis à jour
	 */
	async updateProduit(societeId, produitId, produit) {
		const url = `${__configuration.apiUrl}/massia/eco-organisme-inertes/${produitId}/societes/${societeId}`;
		const res = await this.$http.put(url, produit);
		return res.data;
	}

	/**
	 * Supprimer un produit éco-organisme
	 * @param {number} societeId - ID de la société
	 * @param {number} produitId - ID du produit
	 * @returns {Promise<void>}
	 */
	async deleteProduit(societeId, produitId) {
		const url = `${__configuration.apiUrl}/massia/eco-organisme-inertes/${produitId}/societes/${societeId}`;
		const res = await this.$http.delete(url);
		return res.data;
	}

	/**
	 * Vérifier l'unicité du code
	 * @param {string} codeDechet - Code à vérifier
	 * @param {number} excludeId - ID du produit à exclure (pour l'édition)
	 * @returns {Promise<boolean>} - true si le code existe déjà
	 */
	async checkCodeExists(societeId, codeDechet, excludeId = null) {
		const url = `${__configuration.apiUrl}/massia/eco-organisme-inertes/check-code`;
		const res = await this.$http.get(url, {
			params: {
				societeId: societeId,
				codeDechet: codeDechet,
				excludeId: excludeId
			}
		});
		return res.data;
	}
}
